<div class="amount">
  {{ bid.amount | currency:'JPY':'symbol-narrow' }}
</div>
<div *ngIf="bid.commission" class="commission">
  {{ commissionPrefix | translate }}<span *ngIf="renderColon">: </span>{{ bid.commission | currency:'JPY':'symbol-narrow' }}
</div>
